import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Col } from "react-bootstrap";
import {
  Home,
  ChevronLeft,
  ChevronRight,
  ArrowLeft
} from "lucide-react";
import "./LeftPanel.css";
import {
  getTeacherDashboardAdminUrl,
  returnToTeacherDashboard
} from "../utils/teacherDashboard";

function LeftPanel() {
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleReturnToTD = (event) => {
    event.preventDefault();
    returnToTeacherDashboard();
  };

  const navItems = [
    { to: "/masterdashboard", label: "Home", icon: Home, color: "#3b82f6" },
  ];

  return (
    <Col sm={2} className={`left-panel ${isCollapsed ? "collapsed" : ""}`}>
      {/* ✅ NEW: Alpaca Logo Section */}
      <div className="panel-logo-section">
        <img 
          src="/assets/imgs/Alpaca-logo-white-outline.png" 
          alt="Alpaca Logo" 
          className={`alpaca-logo ${isCollapsed ? "collapsed" : ""}`}
        />
      </div>

      <div className="panel-header">
        <button 
          className="collapse-toggle"
          onClick={() => setIsCollapsed(!isCollapsed)}
          aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {isCollapsed ? <ChevronRight size={20} /> : <ChevronLeft size={20} />}
        </button>
      </div>

      <nav className="side-nav">
        <ul className="nav-list">
          <li>
              <a
                href={getTeacherDashboardAdminUrl()}
                className="nav-item return-to-td"
                onClick={handleReturnToTD}
                title={isCollapsed ? "Return to Teacher Dashboard" : ""}
              >
                <ArrowLeft className="nav-icon" size={20} style={{ color: "#4da6bf" }} />
                {!isCollapsed && <span className="nav-label">Back to Teacher Dashboard</span>}
              </a>
          </li>

          {/* {navItems.map(({ to, label, icon: Icon, color }) => (
            <li key={to}>
              <Link
                to={to}
                className={`nav-item ${location.pathname === to ? "active" : ""}`}
                title={isCollapsed ? label : ""}
              >
                <Icon className="nav-icon" size={20} style={{ color }} />
                {!isCollapsed && <span className="nav-label">{label}</span>}
              </Link>
            </li>
          ))} */}
        </ul>
      </nav>
    </Col>
  );
}

export default LeftPanel;
